/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13011f5b1dd211b17f4304eac13ed7e0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */
export { CustomerServiceManagementLogo } from './logo';
export { CustomerServiceManagementLogoCS } from './logo-cs';
export { CustomerServiceManagementIcon } from './icon';
